import React, { useState } from "react";
import faqData from "../../Data/faqData";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full mx-auto p-4 py-8 bg-blue-50 my-8">
      <h2 className="text-3xl text-slate-800 font-bold text-center mb-6">
        Frequently Asked Questions
      </h2>
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className=" bg-yellow-400 text-slate-800 rounded-lg shadow-md"
          >
            <div
              className="p-4 cursor-pointer flex justify-between items-center"
              onClick={() => toggleAccordion(index)}
            >
              <h3 className="text-lg font-semibold">{faq.question}</h3>
              <span className="text-2xl">
                {openIndex === index ? "-" : "+"}
              </span>
            </div>
            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out max-h-0 ${
                openIndex === index ? "max-h-96" : ""
              }`}
            >
              {openIndex === index && (
                <div className="p-4 border-t border-gray-700 text-slate-700">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
